<script lang="ts">
    import { onMount, onDestroy } from "svelte";
    import { register } from "swiper/element/bundle";
    import "swiper/css";
    import { isMobile } from "../../helpers";

    register();

    interface Amenity {
        title: string;
        description: string[];
        img: string;
        bgColor: string;
        textColor: string;
        listType: string;
    }

    let locationName: string = "";
    let amenitiesList: Amenity[] = [];

    let amenities: Record<string, Amenity[]> = {
        "denver downtown": [
            {
                title: "Perfect for <span class='block sm:inline'>any occasion</span>",
                description: [
                    "Bachelor/ettes, Birthdays",
                    "Team-Building, Anniversaries",
                ],
                img: "/wp-content/themes/badaxe/img/v3/occasions/denver-occasions.jpg",
                // bgColor: "bg-red-500",
                bgColor: "bg-black",
                textColor: "text-white",
                listType: "list-type--green",
            },
            {
                title: "The coolest bar <span class='block sm:inline'>on colfax</span>",
                description: ["Fully licensed bar", "Conveniently Located"],
                img: "/wp-content/themes/badaxe/img/v3/occasions/denver-coolest-bar.jpg",
                // bgColor: "bg-gradient-to-b from-red-500 to-black",
                bgColor: "bg-black",
                textColor: "text-white",
                // listType: "list-type--red",
                listType: "list-type--green",
            },
            {
                title: "14 Axe throwing targets",
                description: [
                    "Perfect for Parties & Events",
                    "Great for Date Nights",
                ],
                img: "/wp-content/themes/badaxe/img/v3/occasions/denver-targets.jpg",
                // bgColor: "bg-red-700",
                bgColor: "bg-black",
                textColor: "text-white",
                listType: "list-type--green",
            },
            {
                title: "Unleash your inner Lumberjack",
                description: ["Big Axe & Knife Throwing", "Expert Coaches"],
                img: "/wp-content/themes/badaxe/img/v3/occasions/denver-unleash-lumberjack.jpg",
                // bgColor: "bg-gray-300",
                bgColor: "bg-black",
                // textColor: "text-black",
                textColor: "text-white",
                // listType: "list-type--red",
                listType: "list-type--green",
            },
            {
                title: "Walk-ins Available",
                description: ["Check our Schedule For Walk-In Availability"],
                img: "/wp-content/themes/badaxe/img/v3/occasions/denver-walkins-available.jpg",
                // bgColor: "bg-yellow-400",
                bgColor: "bg-black",
                // textColor: "text-black",
                textColor: "text-white",
                // listType: "list-type--red",
                listType: "list-type--green",
            },
        ],
        alexandria: [
            {
                title: "The coolest bar <span class='block sm:inline'>in Alexandria</span>",
                description: [
                    "Bachelor/ettes, Birthdays",
                    "Team-Building, Anniversaries",
                ],
                img: "/wp-content/themes/badaxe/img/v3/occasions/alexandria-coolest-bar.jpg",
                // bgColor: "bg-gradient-to-b from-red-500 to-black",
                bgColor: "bg-black",
                textColor: "text-white",
                // listType: "list-type--red",
                listType: "list-type--green",
            },
            {
                title: "Perfect for <span class='block sm:inline'>any occasion</span>",
                description: ["Fully licensed bar", "Conveniently Located"],
                img: "/wp-content/themes/badaxe/img/v3/occasions/alexandria-occasions.jpg",
                // bgColor: "bg-red-500",
                bgColor: "bg-black",
                textColor: "text-white",
                listType: "list-type--green",
            },
            {
                title: "14 Axe throwing targets",
                description: [
                    "Perfect for Parties & Events",
                    "Great for Date Nights",
                ],
                img: "/wp-content/themes/badaxe/img/v3/occasions/alexandria-targets.jpg",
                // bgColor: "bg-red-700",
                bgColor: "bg-black",
                textColor: "text-white",
                listType: "list-type--green",
            },
            {
                title: "Unleash your inner Lumberjack",
                description: ["Big Axe & Knife Throwing", "Expert Coaches"],
                img: "/wp-content/themes/badaxe/img/v3/occasions/alexandria-unleash-lumberjack.jpg",
                // bgColor: "bg-gray-300",
                bgColor: "bg-black",
                // textColor: "text-black",
                textColor: "text-white",
                // listType: "list-type--red",
                listType: "list-type--green",
            },
            {
                title: "Walk-ins Available",
                description: ["Check our Schedule For Walk-In Availability"],
                img: "/wp-content/themes/badaxe/img/v3/occasions/alexandria-walkins.jpg",
                // bgColor: "bg-yellow-400",
                bgColor: "bg-black",
                // textColor: "text-black",
                textColor: "text-white",
                // listType: "list-type--red",
                listType: "list-type--green",
            },
        ],
        charlotte: [
            {
                title: "The best bar in Charlotte",
                description: ["Fully licensed bar", "Conveniently Located"],
                img: "/wp-content/themes/badaxe/img/v3/occasions/charlotte-coolest-bar.jpg",
                // bgColor: "bg-gradient-to-b from-red-500 to-black",
                bgColor: "bg-black",
                textColor: "text-white",
                // listType: "list-type--red",
                listType: "list-type--green",
            },
            {
                title: "Perfect for <span class='block sm:inline'>any occasion</span>",
                description: [
                    "Bachelor/ettes, Birthdays",
                    "Team-Building, Anniversaries",
                ],
                img: "/wp-content/themes/badaxe/img/v3/occasions/charlotte-occasions.jpg",
                // bgColor: "bg-red-500",
                bgColor: "bg-black",
                textColor: "text-white",
                listType: "list-type--green",
            },
            {
                title: "18 Axe throwing targets",
                description: [
                    "Perfect for Parties & Events",
                    "Great for Date Nights",
                ],
                img: "/wp-content/themes/badaxe/img/v3/occasions/charlotte-targets.jpg",
                // bgColor: "bg-red-700",
                bgColor: "bg-black",
                textColor: "text-white",
                listType: "list-type--green",
            },
            {
                title: "Unleash your inner Lumberjack",
                description: ["Big Axe & Knife Throwing", "Expert Coaches"],
                img: "/wp-content/themes/badaxe/img/v3/occasions/charlotte-unleash-lumberjack.jpg",
                // bgColor: "bg-gray-300",
                bgColor: "bg-black",
                // textColor: "text-black",
                textColor: "text-white",
                // listType: "list-type--red",
                listType: "list-type--green",
            },
            {
                title: "Walk-ins Available",
                description: ["Check our Schedule For Walk-In Availability"],
                img: "/wp-content/themes/badaxe/img/v3/occasions/charlotte-walkins.jpg",
                // bgColor: "bg-yellow-400",
                bgColor: "bg-black",
                // textColor: "text-black",
                textColor: "text-white",
                // listType: "list-type--red",
                listType: "list-type--green",
            },
        ],
        waterloo: [
            {
                title: "The most Canadian Pass-Time",
                description: ["Fully licensed bar", "Conveniently Located"],
                img: "/wp-content/themes/badaxe/img/v3/occasions/waterloo-coolest-bar.jpg",
                // bgColor: "bg-gradient-to-b from-red-500 to-black",
                bgColor: "bg-black",
                textColor: "text-white",
                // listType: "list-type--red",
                listType: "list-type--green",
            },
            {
                title: "Perfect for <span class='block sm:inline'>any occasion</span>",
                description: [
                    "Bachelor/ettes, Birthdays",
                    "Team-Building, Anniversaries",
                ],
                img: "/wp-content/themes/badaxe/img/v3/occasions/waterloo-occasions.jpg",
                // bgColor: "bg-red-500",
                bgColor: "bg-black",
                textColor: "text-white",
                listType: "list-type--green",
            },
            {
                title: "10 Axe throwing targets",
                description: [
                    "Perfect for Parties & Events",
                    "Great for Date Nights",
                ],
                img: "/wp-content/themes/badaxe/img/v3/occasions/waterloo-targets.jpg",
                // bgColor: "bg-red-700",
                bgColor: "bg-black",
                textColor: "text-white",
                listType: "list-type--green",
            },
            {
                title: "Unleash your inner Lumberjack",
                description: ["Big Axe & Knife Throwing", "Expert Coaches"],
                img: "/wp-content/themes/badaxe/img/v3/occasions/waterloo-unleash-lumberjack.jpg",
                // bgColor: "bg-gray-300",
                bgColor: "bg-black",
                // textColor: "text-black",
                textColor: "text-white",
                // listType: "list-type--red",
                listType: "list-type--green",
            },
            {
                title: "Walk-ins Available",
                description: ["Check our Schedule For Walk-In Availability"],
                img: "/wp-content/themes/badaxe/img/v3/occasions/waterloo-walkins.jpg",
                // bgColor: "bg-yellow-400",
                bgColor: "bg-black",
                // textColor: "text-black",
                textColor: "text-white",
                // listType: "list-type--red",
                listType: "list-type--green",
            },
        ],
        "minneapolis (city center)": [
            {
                title: "Easy-Access <span class='block sm:inline'>Through City Center Mall</span>",
                description: ["Fully licensed bar", "Conveniently Located"],
                img: "/wp-content/themes/badaxe/img/v3/occasions/minneapoliscc-coolest-bar.jpg",
                // bgColor: "bg-gradient-to-b from-red-500 to-black",
                bgColor: "bg-black",
                textColor: "text-white",
                // listType: "list-type--red",
                listType: "list-type--green",
            },
            {
                title: "Perfect for <span class='block sm:inline'>any occasion</span>",
                description: [
                    "Bachelor/ettes, Birthdays",
                    "Team-Building, Anniversaries",
                ],
                img: "/wp-content/themes/badaxe/img/v3/occasions/minneapoliscc-occasions.jpg",
                // bgColor: "bg-red-500",
                bgColor: "bg-black",
                textColor: "text-white",
                listType: "list-type--green",
            },
            {
                title: "18 Axe throwing targets",
                description: [
                    "Perfect for Parties & Events",
                    "Great for Date Nights",
                ],
                img: "/wp-content/themes/badaxe/img/v3/occasions/minneapoliscc-targets.jpg",
                // bgColor: "bg-red-700",
                bgColor: "bg-black",
                textColor: "text-white",
                listType: "list-type--green",
            },
            {
                title: "Unleash your inner Lumberjack",
                description: ["Big Axe & Knife Throwing", "Expert Coaches"],
                img: "/wp-content/themes/badaxe/img/v3/occasions/minneapoliscc-unleash-lumberjack.jpg",
                // bgColor: "bg-gray-300",
                bgColor: "bg-black",
                // textColor: "text-black",
                textColor: "text-white",
                // listType: "list-type--red",
                listType: "list-type--green",
            },
            {
                title: "Walk-ins Available",
                description: ["Check our Schedule For Walk-In Availability"],
                img: "/wp-content/themes/badaxe/img/v3/occasions/minneapoliscc-walkins.jpg",
                // bgColor: "bg-yellow-400",
                bgColor: "bg-black",
                // textColor: "text-black",
                textColor: "text-white",
                // listType: "list-type--red",
                listType: "list-type--green",
            },
        ],
        syracuse: [
            {
                title: "Way more fun than <span class='block sm:inline'>The Statue of Liberty</span>",
                description: ["Fully licensed bar", "Conveniently Located"],
                img: "/wp-content/themes/badaxe/img/v3/occasions/syracuse-coolest-bar.jpg",
                // bgColor: "bg-gradient-to-b from-red-500 to-black",
                bgColor: "bg-black",
                textColor: "text-white",
                // listType: "list-type--red",
                listType: "list-type--green",
            },
            {
                title: "Perfect for <span class='block sm:inline'>any occasion</span>",
                description: [
                    "Bachelor/ettes, Birthdays",
                    "Team-Building, Anniversaries",
                ],
                img: "/wp-content/themes/badaxe/img/v3/occasions/syracuse-occasions.jpg",
                // bgColor: "bg-red-500",
                bgColor: "bg-black",
                textColor: "text-white",
                listType: "list-type--green",
            },
            {
                title: "10 Axe throwing targets",
                description: [
                    "Perfect for Parties & Events",
                    "Great for Date Nights",
                ],
                img: "/wp-content/themes/badaxe/img/v3/occasions/syracuse-targets.jpg",
                // bgColor: "bg-red-700",
                bgColor: "bg-black",
                textColor: "text-white",
                listType: "list-type--green",
            },
            {
                title: "Unleash your inner Lumberjack",
                description: ["Big Axe & Knife Throwing", "Expert Coaches"],
                img: "/wp-content/themes/badaxe/img/v3/occasions/syracuse-unleash-lumberjack.jpg",
                // bgColor: "bg-gray-300",
                bgColor: "bg-black",
                // textColor: "text-black",
                textColor: "text-white",
                // listType: "list-type--red",
                listType: "list-type--green",
            },
            {
                title: "Walk-ins Available",
                description: ["Check our Schedule For Walk-In Availability"],
                img: "/wp-content/themes/badaxe/img/v3/occasions/syracuse-walkins.jpg",
                // bgColor: "bg-yellow-400",
                bgColor: "bg-black",
                // textColor: "text-black",
                textColor: "text-white",
                // listType: "list-type--red",
                listType: "list-type--green",
            },
        ],
    };

    onMount(async () => {
        // const swiperEl = document.querySelector("swiper-container");
        const swiperEl = document.querySelector("#swiper-amenities");
        const prevBtn = document.querySelector("#prev-btn-amenities");
        const nextBtn = document.querySelector("#next-btn-amenities");

        prevBtn?.addEventListener("click", () => {
            swiperEl?.swiper.slidePrev();
            swiperEl?.swiper.autoplay.stop();
        });
        nextBtn?.addEventListener("click", () => {
            swiperEl?.swiper.slideNext();
            swiperEl?.swiper.autoplay.stop();
        });

        const parentEl = document.querySelector("#location-amenities-options");
        locationName = parentEl?.getAttribute("data-location") as string;

        amenitiesList = amenities[locationName.toLowerCase()];
    });

    // on destroy action
    onDestroy(() => {
        locationName = "";
    });
</script>

<div class="mx-auto container my-8 relative">
    <swiper-container
        id="swiper-amenities"
        slides-per-view={`${isMobile() ? 1.2 : 3}`}
        loop="true"
        space-between="30"
        autoplay-delay="4000"
    >
        {#each amenitiesList as amenity}
            <swiper-slide>
                <img
                    src={amenity.img}
                    alt={amenity.title}
                    class="object-cover h-44 w-full"
                />
                <div
                    class={`px-6 py-4 flex flex-col items-start justify-start h-52 sm:h-44 pt-8 ${amenity.bgColor}`}
                >
                    <h3
                        class={`text-center sm:text-left text-xl sm:text-2xl font-bold font-helveticaneue uppercase leading-6 w-full ${amenity.textColor}`}
                    >
                        {@html amenity.title}
                    </h3>
                    <ul
                        class={`mt-1 font-bold font-helveticaneue w-full text-sm ${amenity.textColor}`}
                    >
                        {#each amenity.description as desc}
                            <li
                                class={`flex flex-row items-center justify-start my-1 w-full ${amenity.listType}`}
                            >
                                {desc}
                            </li>
                        {/each}
                    </ul>
                </div>
            </swiper-slide>
        {/each}
    </swiper-container>
    <button
        id="prev-btn-amenities"
        class="absolute left-2 sm:-left-10 z-30 inset-y-1/2 border-2 border-white sm:border-black rounded-full h-8 w-8 flex items-center justify-center"
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            class="h-6 w-6 text-white sm:text-black"
            ><path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 19l-7-7 7-7"
            ></path></svg
        >
    </button>
    <button
        id="next-btn-amenities"
        class="absolute right-2 sm:-right-10 z-30 inset-y-1/2 border-2 border-white sm:border-black rounded-full h-8 w-8 flex items-center justify-center"
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            class="h-6 w-6 text-white sm:text-black"
            ><path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
            ></path></svg
        >
    </button>
</div>

<style>
    .list-type--green::before {
        content: "";
        display: inline-block;
        width: 16px;
        height: 16px;
        background-image: url("/wp-content/themes/badaxe/img/v3/occasions/green-checkmark.png");
        background-size: contain;
        background-repeat: no-repeat;
        margin-right: 10px;
    }
    .list-type--red::before {
        content: "";
        display: inline-block;
        width: 16px;
        height: 16px;
        background-image: url("/wp-content/themes/badaxe/img/v3/occasions/red-checkmark.png");
        background-size: contain;
        background-repeat: no-repeat;
        margin-right: 10px;
    }

    .swiper {
        width: 100%;
        height: 100%;
    }
    .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .swiper-button-next {
        color: red !important;
    }
    .swiper-slide:first-child {
        margin-left: 200px;
    }
</style>
